import React from 'react';
import SectionMessage from '@atlaskit/section-message';

import { Wrapper } from './UploadSuccessMessageStyled';

interface Props {
    fileName?: string;
    optionsAdded?: number;
    optionsUpdated?: number;
}

const UploadSuccessMessage: React.FC<Props> = ({ fileName = '', optionsAdded = 0, optionsUpdated = 0 }) => (
    <Wrapper>
        <SectionMessage appearance='success'>
            File <b>{fileName}</b> uploaded correctly. The field will contain:
            <ul>
                <li>
                    <b>{optionsAdded}</b> options added,
                </li>
                <li>
                    <b>{optionsUpdated}</b> options updated.
                </li>
            </ul>
            <br />
            Click <b>Import</b> to get started.
        </SectionMessage>
    </Wrapper>
);

export default UploadSuccessMessage;
